import { render, staticRenderFns } from "./app-footer.vue?vue&type=template&id=e411f4ee&scoped=true"
import script from "./app-footer.vue?vue&type=script&lang=js"
export * from "./app-footer.vue?vue&type=script&lang=js"
import style0 from "./app-footer.vue?vue&type=style&index=0&id=e411f4ee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e411f4ee",
  null
  
)

export default component.exports